import dayjs from "dayjs";

export enum Type {
    Hygienist = 0,
    Assistant = 1,
}

export const HYGIENIST_TYPES = {
    HYGIENIST: 0,
    ASSISTANT: 1,
    FRONT_DESK: 2,
    ASSOCIATE_DENTIST: 3
} as const;

export interface SkillsProps {
    id: number
    hygienistId: number
    skillId: number
    hygienistType: number
    label: string
    name: string
    description: string
    certified: string
    qualification: number
    license: number
}

export interface PartialOffer {
    id: number
    jobId: number
    hygienistId: number
    offeredStartTime: string
    offeredEndTime: string
    offeredStartTimeLocal?: string
    offeredEndTimeLocal?: string
    status: number
    createdOn: string
    modifiedOn: any
    statusChangeOn: any
    hourlyRate: number
    submitTimestamp: any
    resubmittedOn: any
    isResubmitRequested: number
    numViews: any
    firstViewed: any
    lastViewed: any
    fh_id: number
    isFavouriteHygienist: boolean
    expiresAt: string
    hygienist: OfferHygienist
    location?: Location
    job?: JobProps
}

export interface OfferHygienist {
    firstName: string
    lastName: string
    graduationYear: number
    school: string
    CDHONumber: string
    starScore: number
    phone: string
    numBooked: number
    resumeUrl: any
    province: string
    country: number
    level: number
    photoUrl: string
    isReliable: number
    status: number
    type: number
    completedJobs: number
    vaxStatus: number
    isLeftHanded?: number
    skills: SkillsProps[]
    about?: string
    numRatedJobs?: number
}

export enum COUNTRY {
    'US' = 1,
    'CA' = 0,
}
export type Location = {
    status?: number;
    id: number,
    email: string,
    address: string,
    city: string,
    province: string,
    hasCard: boolean,
    country: COUNTRY,
    stripeCustomerId: string,
    removed: number,
    avgApptTime: string,
    primaryContact: string,
    friendlyEndorsed?: number,
    equipEndorsed?: number,
    ppeEndorsed?: boolean;
    parking: string,
    radiography: string,
    ultrasonic: string,
    charting: string,
    software: string,
    practiceName?: string,
    isCardValid?: boolean,
    postalCode: string,
    lat: number,
    lon: number,
    card?: {
        last4: string,
        type: string
    },
    isCentralBooked?: number,
}

export interface HygienistProps {
    id: number,
    firstName: string,
    lastName: string,
    about?: string,
    address: string,
    city: string,
    country: 0 | 1,
    school?: string,
    AvailableNow: number,
    status: number,
    type: 0 | 1 | 2 | 3, // 0 - hyg, 1 - ast, 2 - admin/manager
    Verified: 0 | 1,
    countryStr: string,

    InstabookActivated: 0 | 1,
    PriorityNotifications: 0 | 1,
    WeeklyNewsletter: 0 | 1,
    blockedUntil: number | null,
    completedJobs: number,
    createdOn: string,
    enabled: 0 | 1,
    engagedPromotionStatus: 0 | 1,
    etransferEmail: null,
    googleReviewed: 0 | 1,
    graduationYear: number,
    hireResumeUrl: null,
    isComplete: 0 | 1,
    isJobBoardHelpMsgSeen: 0 | 1,
    isOrtho: 0 | 1,
    isReliable: 0 | 1,
    isRestorative: 0 | 1,
    level: number | undefined,
    maxBooked: number,
    maxRate: number | null,
    numJobApplications: number,
    phone: string,
    photoUrl: string | null,
    postalCode: string,
    province: string,
    receivePostedShifts: 0 | 1,
    resumeUrl: string | undefined,
    seenPhoto: 0 | 1,
    stericenter: null,
    uploadedPhoto: 0 | 1,
    CDHONumber?: number | null,
    skills?: SkillsProps[],
    isLeftHanded?: 0 | 1,
    lat?: number,
    lon?: number,
}

export interface DentistProps {
    cancelledShiftsNum: number
    completedJobs: number
    country: number
    countryStr: string
    disengagedPromotionStatus: number
    engagedPromotionStatus: number
    googleReviewed: number
    id: number
    isComplete: number
    newTermsSeenOn: string
    nonPaymentReportsNum: number
    tempAmount: number
}

export interface UserAccountProps {
    country: number;
    id: number
    seenTokensInfo?: 0 | 1
    TokenAmount?: number
    email: string
    dentistId?: number
    hygienistId?: number
    dentist?: DentistProps
    hygienist?: HygienistProps
    locations?: Location[]
}

export interface ShiftProps {
    actualEnd: TimeString | null ,
    actualStart: TimeString | null,
    gapUnpaid: number,
    id: number,
    jobId: number,
    postedEnd: string,
    postedStart: string,
    shiftDate: string,
    type: number,
    unpaidHours: number | null,
}

/**
 * `YYYY-MM-DD` formated date
 */
export type DateString = string & { readonly brand: unique symbol };

/**
 * `h:mm a` formated time
 */
export type TimeString = string & { readonly brand: unique symbol };

export enum JOB_STATUSES {
    POSTED = 1,
    PARTIAL = 2,
    CONFIRMED = 3,
    COMPLETED = 4,
    OFFER_EXPIRED = 5,
}

export interface JobProps {
    Autobook: number,
    Instabook: number,
    dentistId: number,
    hourlyRate: number,
    bookedOn?: string,

    hygienistId: number,


    dentistRating?: number,
    dentistPrivateNotes?: string,

    avgRate?: number,
    distanceObj?: {
        distance: { text: string, value: number },
        duration: { text: string, value: number }
    },

    id: number,
    distance: string,

    isFavouriteDentist: number,
    isHided: boolean,

    offer_status?: number,

    isOrtho?: number,
    isRestorative?: number,

    location: Location, // LocationProps
    locationId: number,
    partialOffers: any[],
    paymentTerms: number;
    paysW2: 0 | 1 | 2,
    postedOn: string,

    ppe?: any,
    proposedRate: number,

    reposted: 0 | 1 | null,
    requiredLevel?: number,
    requiredN95?: number,
    shiftCancelled?: number,

    shifts: ShiftProps[],
    startDate: DateString,
    status: JOB_STATUSES,
    timeZone?: string,
    type: 0 | 1, // 0 - hyg, 1 - ast
    paymentMethod: number | null,
    ghr?: number,
}

export interface JobPropsWithHygienist extends JobProps {
    cancelledOffer: boolean;
    hygienist: OfferHygienist
}

export interface InvoiceProps {
    id: number
    jobId: number
    createdOn: string
    creditPaid: number | null
    dentistMarkedPaid: number
    hourlyRate: number
    hygienistMarkedPaid: number
    manualDentistId: number | null
    manualHygienistId: number | null
    nonPaymentReportedOn: string | null
    notes: string | null
    paidOn: string | null
    resolved: number | null
    sent: number | null
    sentOn: string | null
    ticketLinks: string | null
    totalBillableHours: number | null
    totalHours: number
    totalInvoiceAmt: number
    totalUnpaidHours: number
    travelAllowance: number | null
    unresolved: number | null
}

export interface AutocompleteProps {
    buildingNumber?: string
    state: string,
    city?: string,
    postalCode?: string,
    address?: string,
    valueEqual?: boolean
}

export type PositionProps = {
    id: number;
    userId: number;
    jobTitle: string,
    companyName: string,
    city: string,
    employmentType: string,
    current: boolean,
    fromDate: dayjs.Dayjs | string,
    toDate: dayjs.Dayjs | string,
}

export interface BasicHygienistScoreProps {
    cancellationScore: number,
    overallReliability: number,
    recentReliability: number,
    weightedReliability: number,
}

export interface HygienistScoreProps extends BasicHygienistScoreProps {
    cancellations: number,
    cancellations30Days: number,
    cancellations90Days: number,
    completed: number,
    completed30Days: number,
    completed90Days: number,
    newCancellationScore: number,
    newOverallScore: number,
    newRecentScore: number,
    newWeightedScore: number,
}
